var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAudioLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "audio-loading",
    width: 80,
    height: 73,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.665 17.83c21.172-21.172 55.498-21.172 76.67 0a.976.976 0 0 0 1.38-1.38C57.78-5.483 22.218-5.483.284 16.45a.976.976 0 1 0 1.38 1.38Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "0.4s"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.63 27.794c15.668-15.67 41.072-15.67 56.74 0a.976.976 0 1 0 1.38-1.38c-16.43-16.431-43.07-16.431-59.5 0a.976.976 0 0 0 1.38 1.38Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "0.2s"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.685 39.46c-10.157-10.158-26.626-10.158-36.783 0a.976.976 0 1 1-1.38-1.38c10.92-10.92 28.623-10.92 39.543 0a.976.976 0 1 1-1.38 1.38Z"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    repeatCount: "indefinite",
    dur: "1s",
    values: "0;1;1",
    keyTimes: "0;0.2;1",
    begin: "0.0s"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.22 59.879a1.743 1.743 0 1 0 2.465-2.466 1.743 1.743 0 0 0-2.466 2.466ZM50.298 51.265a1.743 1.743 0 1 1-2.466-2.465 1.743 1.743 0 0 1 2.466 2.465ZM43.526 55.572a1.743 1.743 0 1 0 2.465-2.466 1.743 1.743 0 0 0-2.465 2.466ZM45.288 47.331a1.743 1.743 0 1 1-3.368-.902 1.743 1.743 0 0 1 3.368.902ZM37.75 48.564a1.743 1.743 0 1 0-.902-3.368 1.743 1.743 0 0 0 .902 3.368ZM33.072 48.8a1.743 1.743 0 1 1-2.466 2.465 1.743 1.743 0 0 1 2.465-2.465ZM30.37 55.944a1.743 1.743 0 1 0-3.368-.902 1.743 1.743 0 0 0 3.368.902ZM28.235 60.115a1.743 1.743 0 1 1 .902 3.368 1.743 1.743 0 0 1-.902-3.368ZM33.072 66.026a1.743 1.743 0 1 0-2.466 2.466 1.743 1.743 0 0 0 2.465-2.466ZM35.615 69.96a1.743 1.743 0 1 1 3.368.902 1.743 1.743 0 0 1-3.368-.902ZM43.153 68.728a1.743 1.743 0 1 0 .903 3.368 1.743 1.743 0 0 0-.903-3.368ZM47.832 68.492a1.743 1.743 0 1 1 2.466-2.466 1.743 1.743 0 0 1-2.466 2.466ZM50.533 61.347a1.744 1.744 0 1 0 3.369.902 1.744 1.744 0 0 0-3.369-.902ZM52.669 57.177a1.743 1.743 0 1 1-.903-3.368 1.743 1.743 0 0 1 .903 3.368ZM39.327 54.447a1.743 1.743 0 1 0-.903-3.368 1.743 1.743 0 0 0 .903 3.368ZM35.02 55.386a1.743 1.743 0 1 1-.902 3.367 1.743 1.743 0 0 1 .902-3.367ZM37.378 61.72a1.743 1.743 0 1 0-2.465 2.465 1.743 1.743 0 0 0 2.465-2.465ZM40.344 64.98a1.743 1.743 0 1 1 3.368-.903 1.743 1.743 0 0 1-3.368.903ZM44.65 59.77a1.743 1.743 0 1 0 3.369.903 1.743 1.743 0 0 0-3.368-.902Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioLoading);
export default __webpack_public_path__ + "static/media/audio-loading.637d2c7fcf84bc4483ff29b6e202719b.svg";
export { ForwardRef as ReactComponent };